import {
  ButtonWithIcon,
  CaretDownIcon,
  CaretUpIcon,
  Link,
} from "/App.Components";
import "./OrganizationOverviewItem.scss";
import { OrganizationOverviewItemProps } from "/Models/Generated/OrganizationOverviewItemProps";
import { useState } from "react";
import cn from "classnames";

interface OrganizationOverviewItemExtendedProps
  extends OrganizationOverviewItemProps {
  id: string;
}

const OrganizationOverviewItem = ({
  expandButtonText,
  expandedText,
  heading,
  headingHref,
  links,
  id,
}: OrganizationOverviewItemExtendedProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const itemId = `organization-item-${id}`;

  return (
    <section
      className={cn("organization-overview-item", {
        "organization-overview-item--expanded": isOpen,
      })}
    >
      <a href={headingHref}>
        <h2 className="organization-overview-item__heading">
          <span>{heading}</span>
        </h2>
      </a>
      {expandedText || (links?.length ?? 0) > 0 ? (
        <>
          <ButtonWithIcon
            icon={isOpen ? CaretUpIcon : CaretDownIcon}
            iconPlacement="after"
            onClickHandler={() => setIsOpen((prev) => !prev)}
            text={expandButtonText}
            ariaExpanded={isOpen}
            ariaControls={itemId}
          />
          {isOpen && (
            <div id={itemId}>
              {expandedText && (
                <span className="organization-overview-item__text">
                  {expandedText}
                </span>
              )}
              {links && (
                <ul className="organization-overview-item__list">
                  {links.map((link, idx) => (
                    <li key={idx}>
                      <Link {...link} hasUnderline size="x-small" />
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </>
      ) : null}
    </section>
  );
};

export default OrganizationOverviewItem;
